import React, { Component } from 'react';
import { Card, Header, Button, Image, Icon, Form, Feed, Divider, Menu, Grid } from 'semantic-ui-react'
import axios from 'axios'
import { Link } from 'react-router-dom';
import * as UiConsts from '../../../../config/UiConstants';
import { pythonApiIp, getOrderKey } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';
import { algoliaPartialUpdateOrder } from '../algoliaDashboard/AlgoliaMiscUtils';

class CheckOrderProjectInfo extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            loading:false
         }
    }

    checkOrderProjectInfo = () => {
        console.log("cpx1 ======checkOrderProjectInfo");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'checkOrderProjectInfo', {
            apiKey: "checkOrderProjectInfo",
            fbOrderKey: getOrderKey(this.props.order),
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(JSON.stringify(response.data,null,3));

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    if(response.data.partOfProject){
                        alert("part of project:"+response.data.order.largeproject.name+" id:"+response.data.order.idlargeprojects);

                        
                        if(this.props.order.archived || this.props.order.algoliaArchived){
                            console.log("this.props.order.archived || this.props.order.algoliaArchived is true");
                            let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                            let orderUpdates = {
                                largeproject: response.data.order.largeproject.name,
                                largeprojectid: response.data.order.largeproject.idlargeprojects,
                                largeprojectcustomer: response.data.order.largeproject.largeprojectcustomer.customername,
                                largeprojectcustomerid: response.data.order.largeproject.largeprojectcustomer.idlargeprojectcustomer,
                                lastUpdated: now,
                                lastUpdatedBy: this.props.user.email,
                                objectID: getOrderKey(this.props.order)
                            }
                            //UDPATE IN ALGOLIA ONLY
                            algoliaPartialUpdateOrder(orderUpdates);
                        }else{
                            console.log("order is NOT ARCHIVED")

                            let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                            let orderUpdates = {
                                largeproject: response.data.order.largeproject.name,
                                largeprojectid: response.data.order.largeproject.idlargeprojects,
                                largeprojectcustomer: response.data.order.largeproject.largeprojectcustomer.customername,
                                largeprojectcustomerid: response.data.order.largeproject.largeprojectcustomer.idlargeprojectcustomer,
                                lastUpdated: now,
                                lastUpdatedBy: this.props.user.email
                            }
                    
                            FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);
                        }
                    }else if(!response.data.partOfProject){
                        alert("NOT part of project")
                    }
             
                   
                } else {
                    console.log("FAILED");
                    alert("FAILED!!! :" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    
    render() { 

        const checkProjectButton = this.props.order.partOfProject
            ? this.props.order.project
            : <Button onClick={this.checkOrderProjectInfo}>CHECK PROJECT INFO</Button>

        const projectInfo = this.props.order.largeproject
            ? <div>
                <span>project:{this.props.order.largeproject}</span><br/>
                <span>project id:{this.props.order.largeprojectid}</span><br/>
                <span>customer:{this.props.order.largeprojectcustomer}</span><br/>
                <span><Link to={'/dashboard/viewLargeProject/' + this.props.order.largeprojectid} target="_blank">VIEW</Link></span><br/>

            </div>
            :''

        const wholeUi = this.props.algoliaUser && this.props.algoliaUser.viewProjectsInDashboard
            ?<div>
                <Divider horizontal>{'PROJECT INFO'}</Divider>
             {projectInfo}
             {checkProjectButton}<br/>
             <span><Link to={'/dashboard/AddOrderToProject/' + getOrderKey(this.props.order)}>ADD TO PROJECT</Link></span>
            </div>
            :''

        return ( this.state.loading ? <UiConsts.LoadingComponent /> : <div>
             
             {wholeUi}
             
        </div>  );
    }
}
 
export default CheckOrderProjectInfo;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/CheckOrderProjectInfo.js